"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageFileInputBase64Convert = imageFileInputBase64Convert;
/**
 * @description Takes an e.target.files[0] from <input accept="image/*"/> file input. Will return the Base64 encoded string of image.
 * @param file
 * @returns
 */
async function imageFileInputBase64Convert(file) {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
            resolve(fileReader.result);
        };
        fileReader.onerror = (error) => {
            reject(error);
        };
    });
}
